export enum Title {
  MR = 'Mr.',
  MS = 'Ms.',
  MRS = 'Mrs.',
}
